import { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';

const HomePage = lazy(() => import('../pages/HomePage/HomePage'));
const AboutPage = lazy(() => import('../pages/AboutPage/AboutPage'));
const ServicesPage = lazy(() => import('../pages/Services/ServicesPage'));
const ContactPage = lazy(() => import('../pages/ContactPage/ContactPage'));
const ProjectsPage = lazy(() => import('../pages/ProjectPage/ProjectPage'));
const NotFoundPage = lazy(() => import('../pages/NotFoundPage/NotFoundPage'));
const ProjectDetails = lazy(() => import('../pages/ProjectDetails/ProjectDetails'));

const AppRoutes = () => {
  return (
    <Router>
      <Suspense fallback={<div></div>}>
        <div className="app-container">
          <Header />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/solutions" element={<ServicesPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contacts" element={<ContactPage />} />
              <Route path="/projects" element={<ProjectsPage />} />
              <Route path="/projects/:projectID" element={<ProjectDetails />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Suspense>
    </Router>
  );
};

export default AppRoutes;